
ReportLinkController = ($scope) ->
    'ngInject'

    if this.program
        console.log(this.program)
        this.linkParams = angular.extend({}, this.params, {slug: this.program.slug})
        this.location = 'program.reports.' + this.reportId

    else
        this.linkParams = this.params
        this.location = 'reports.' + this.reportId


reportLinkComponent =
    controller: ReportLinkController
    controllerAs: '$ctrl'
    template:  "<a ui-sref='{{$ctrl.location}}($ctrl.linkParams)'><ng-transclude /></a>"
    transclude: true
    bindings:
        program: '='
        reportId: '@'
        params: '=?'


module.component 'reportLink', reportLinkComponent